!(function() {
  'use strict';
  /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ function t(
    t,
    e,
    i,
    s
  ) {
    var n,
      o = arguments.length,
      r = o < 3 ? e : null === s ? (s = Object.getOwnPropertyDescriptor(e, i)) : s;
    if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate) r = Reflect.decorate(t, e, i, s);
    else for (var l = t.length - 1; l >= 0; l--) (n = t[l]) && (r = (o < 3 ? n(r) : o > 3 ? n(e, i, r) : n(e, i)) || r);
    return o > 3 && r && Object.defineProperty(e, i, r), r;
  }
  function e(t, e) {
    if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata) return Reflect.metadata(t, e);
  }
  /**
   * @license
   * Copyright 2019 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ const i = window,
    s =
      i.ShadowRoot &&
      (void 0 === i.ShadyCSS || i.ShadyCSS.nativeShadow) &&
      'adoptedStyleSheets' in Document.prototype &&
      'replace' in CSSStyleSheet.prototype,
    n = Symbol(),
    o = new WeakMap();
  class r {
    constructor(t, e, i) {
      if (((this._$cssResult$ = !0), i !== n))
        throw Error('CSSResult is not constructable. Use `unsafeCSS` or `css` instead.');
      (this.cssText = t), (this.t = e);
    }
    get styleSheet() {
      let t = this.o;
      const e = this.t;
      if (s && void 0 === t) {
        const i = void 0 !== e && 1 === e.length;
        i && (t = o.get(e)),
          void 0 === t && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), i && o.set(e, t));
      }
      return t;
    }
    toString() {
      return this.cssText;
    }
  }
  const l = s
    ? (t) => t
    : (t) =>
        t instanceof CSSStyleSheet
          ? ((t) => {
              let e = '';
              for (const i of t.cssRules) e += i.cssText;
              return ((t) => new r('string' == typeof t ? t : t + '', void 0, n))(e);
            })(t)
          : t;
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ var a;
  const h = window,
    d = h.trustedTypes,
    p = d ? d.emptyScript : '',
    c = h.reactiveElementPolyfillSupport,
    u = {
      toAttribute(t, e) {
        switch (e) {
          case Boolean:
            t = t ? p : null;
            break;
          case Object:
          case Array:
            t = null == t ? t : JSON.stringify(t);
        }
        return t;
      },
      fromAttribute(t, e) {
        let i = t;
        switch (e) {
          case Boolean:
            i = null !== t;
            break;
          case Number:
            i = null === t ? null : Number(t);
            break;
          case Object:
          case Array:
            try {
              i = JSON.parse(t);
            } catch (t) {
              i = null;
            }
        }
        return i;
      }
    },
    v = (t, e) => e !== t && (e == e || t == t),
    $ = { attribute: !0, type: String, converter: u, reflect: !1, hasChanged: v };
  class y extends HTMLElement {
    constructor() {
      super(),
        (this._$Ei = new Map()),
        (this.isUpdatePending = !1),
        (this.hasUpdated = !1),
        (this._$El = null),
        this.u();
    }
    static addInitializer(t) {
      var e;
      this.finalize(), (null !== (e = this.h) && void 0 !== e ? e : (this.h = [])).push(t);
    }
    static get observedAttributes() {
      this.finalize();
      const t = [];
      return (
        this.elementProperties.forEach((e, i) => {
          const s = this._$Ep(i, e);
          void 0 !== s && (this._$Ev.set(s, i), t.push(s));
        }),
        t
      );
    }
    static createProperty(t, e = $) {
      if (
        (e.state && (e.attribute = !1),
        this.finalize(),
        this.elementProperties.set(t, e),
        !e.noAccessor && !this.prototype.hasOwnProperty(t))
      ) {
        const i = 'symbol' == typeof t ? Symbol() : '__' + t,
          s = this.getPropertyDescriptor(t, i, e);
        void 0 !== s && Object.defineProperty(this.prototype, t, s);
      }
    }
    static getPropertyDescriptor(t, e, i) {
      return {
        get() {
          return this[e];
        },
        set(s) {
          const n = this[t];
          (this[e] = s), this.requestUpdate(t, n, i);
        },
        configurable: !0,
        enumerable: !0
      };
    }
    static getPropertyOptions(t) {
      return this.elementProperties.get(t) || $;
    }
    static finalize() {
      if (this.hasOwnProperty('finalized')) return !1;
      this.finalized = !0;
      const t = Object.getPrototypeOf(this);
      if (
        (t.finalize(),
        void 0 !== t.h && (this.h = [...t.h]),
        (this.elementProperties = new Map(t.elementProperties)),
        (this._$Ev = new Map()),
        this.hasOwnProperty('properties'))
      ) {
        const t = this.properties,
          e = [...Object.getOwnPropertyNames(t), ...Object.getOwnPropertySymbols(t)];
        for (const i of e) this.createProperty(i, t[i]);
      }
      return (this.elementStyles = this.finalizeStyles(this.styles)), !0;
    }
    static finalizeStyles(t) {
      const e = [];
      if (Array.isArray(t)) {
        const i = new Set(t.flat(1 / 0).reverse());
        for (const t of i) e.unshift(l(t));
      } else void 0 !== t && e.push(l(t));
      return e;
    }
    static _$Ep(t, e) {
      const i = e.attribute;
      return !1 === i ? void 0 : 'string' == typeof i ? i : 'string' == typeof t ? t.toLowerCase() : void 0;
    }
    u() {
      var t;
      (this._$E_ = new Promise((t) => (this.enableUpdating = t))),
        (this._$AL = new Map()),
        this._$Eg(),
        this.requestUpdate(),
        null === (t = this.constructor.h) || void 0 === t || t.forEach((t) => t(this));
    }
    addController(t) {
      var e, i;
      (null !== (e = this._$ES) && void 0 !== e ? e : (this._$ES = [])).push(t),
        void 0 !== this.renderRoot && this.isConnected && (null === (i = t.hostConnected) || void 0 === i || i.call(t));
    }
    removeController(t) {
      var e;
      null === (e = this._$ES) || void 0 === e || e.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
      this.constructor.elementProperties.forEach((t, e) => {
        this.hasOwnProperty(e) && (this._$Ei.set(e, this[e]), delete this[e]);
      });
    }
    createRenderRoot() {
      var t;
      const e =
        null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
      return (
        ((t, e) => {
          s
            ? (t.adoptedStyleSheets = e.map((t) => (t instanceof CSSStyleSheet ? t : t.styleSheet)))
            : e.forEach((e) => {
                const s = document.createElement('style'),
                  n = i.litNonce;
                void 0 !== n && s.setAttribute('nonce', n), (s.textContent = e.cssText), t.appendChild(s);
              });
        })(e, this.constructor.elementStyles),
        e
      );
    }
    connectedCallback() {
      var t;
      void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()),
        this.enableUpdating(!0),
        null === (t = this._$ES) ||
          void 0 === t ||
          t.forEach((t) => {
            var e;
            return null === (e = t.hostConnected) || void 0 === e ? void 0 : e.call(t);
          });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
      var t;
      null === (t = this._$ES) ||
        void 0 === t ||
        t.forEach((t) => {
          var e;
          return null === (e = t.hostDisconnected) || void 0 === e ? void 0 : e.call(t);
        });
    }
    attributeChangedCallback(t, e, i) {
      this._$AK(t, i);
    }
    _$EO(t, e, i = $) {
      var s;
      const n = this.constructor._$Ep(t, i);
      if (void 0 !== n && !0 === i.reflect) {
        const o = (void 0 !== (null === (s = i.converter) || void 0 === s ? void 0 : s.toAttribute)
          ? i.converter
          : u
        ).toAttribute(e, i.type);
        (this._$El = t), null == o ? this.removeAttribute(n) : this.setAttribute(n, o), (this._$El = null);
      }
    }
    _$AK(t, e) {
      var i;
      const s = this.constructor,
        n = s._$Ev.get(t);
      if (void 0 !== n && this._$El !== n) {
        const t = s.getPropertyOptions(n),
          o =
            'function' == typeof t.converter
              ? { fromAttribute: t.converter }
              : void 0 !== (null === (i = t.converter) || void 0 === i ? void 0 : i.fromAttribute)
              ? t.converter
              : u;
        (this._$El = n), (this[n] = o.fromAttribute(e, t.type)), (this._$El = null);
      }
    }
    requestUpdate(t, e, i) {
      let s = !0;
      void 0 !== t &&
        (((i = i || this.constructor.getPropertyOptions(t)).hasChanged || v)(this[t], e)
          ? (this._$AL.has(t) || this._$AL.set(t, e),
            !0 === i.reflect &&
              this._$El !== t &&
              (void 0 === this._$EC && (this._$EC = new Map()), this._$EC.set(t, i)))
          : (s = !1)),
        !this.isUpdatePending && s && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
      this.isUpdatePending = !0;
      try {
        await this._$E_;
      } catch (t) {
        Promise.reject(t);
      }
      const t = this.scheduleUpdate();
      return null != t && (await t), !this.isUpdatePending;
    }
    scheduleUpdate() {
      return this.performUpdate();
    }
    performUpdate() {
      var t;
      if (!this.isUpdatePending) return;
      this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, e) => (this[e] = t)), (this._$Ei = void 0));
      let e = !1;
      const i = this._$AL;
      try {
        (e = this.shouldUpdate(i)),
          e
            ? (this.willUpdate(i),
              null === (t = this._$ES) ||
                void 0 === t ||
                t.forEach((t) => {
                  var e;
                  return null === (e = t.hostUpdate) || void 0 === e ? void 0 : e.call(t);
                }),
              this.update(i))
            : this._$Ek();
      } catch (t) {
        throw ((e = !1), this._$Ek(), t);
      }
      e && this._$AE(i);
    }
    willUpdate(t) {}
    _$AE(t) {
      var e;
      null === (e = this._$ES) ||
        void 0 === e ||
        e.forEach((t) => {
          var e;
          return null === (e = t.hostUpdated) || void 0 === e ? void 0 : e.call(t);
        }),
        this.hasUpdated || ((this.hasUpdated = !0), this.firstUpdated(t)),
        this.updated(t);
    }
    _$Ek() {
      (this._$AL = new Map()), (this.isUpdatePending = !1);
    }
    get updateComplete() {
      return this.getUpdateComplete();
    }
    getUpdateComplete() {
      return this._$E_;
    }
    shouldUpdate(t) {
      return !0;
    }
    update(t) {
      void 0 !== this._$EC && (this._$EC.forEach((t, e) => this._$EO(e, this[e], t)), (this._$EC = void 0)),
        this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
  }
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */
  var g;
  (y.finalized = !0),
    (y.elementProperties = new Map()),
    (y.elementStyles = []),
    (y.shadowRootOptions = { mode: 'open' }),
    null == c || c({ ReactiveElement: y }),
    (null !== (a = h.reactiveElementVersions) && void 0 !== a ? a : (h.reactiveElementVersions = [])).push('1.6.1');
  const f = window,
    m = f.trustedTypes,
    _ = m ? m.createPolicy('lit-html', { createHTML: (t) => t }) : void 0,
    S = `lit$${(Math.random() + '').slice(9)}$`,
    b = '?' + S,
    A = `<${b}>`,
    E = document,
    w = () => E.createComment(''),
    C = (t) => null === t || ('object' != typeof t && 'function' != typeof t),
    x = Array.isArray,
    k = '[ \t\n\f\r]',
    U = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,
    P = /-->/g,
    R = />/g,
    H = RegExp(`>|${k}(?:([^\\s"'>=/]+)(${k}*=${k}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, 'g'),
    O = /'/g,
    N = /"/g,
    T = /^(?:script|style|textarea|title)$/i,
    z = ((t) => (e, ...i) => ({ _$litType$: t, strings: e, values: i }))(1),
    M = Symbol.for('lit-noChange'),
    j = Symbol.for('lit-nothing'),
    L = new WeakMap(),
    B = E.createTreeWalker(E, 129, null, !1),
    D = (t, e) => {
      const i = t.length - 1,
        s = [];
      let n,
        o = 2 === e ? '<svg>' : '',
        r = U;
      for (let e = 0; e < i; e++) {
        const i = t[e];
        let l,
          a,
          h = -1,
          d = 0;
        for (; d < i.length && ((r.lastIndex = d), (a = r.exec(i)), null !== a); )
          (d = r.lastIndex),
            r === U
              ? '!--' === a[1]
                ? (r = P)
                : void 0 !== a[1]
                ? (r = R)
                : void 0 !== a[2]
                ? (T.test(a[2]) && (n = RegExp('</' + a[2], 'g')), (r = H))
                : void 0 !== a[3] && (r = H)
              : r === H
              ? '>' === a[0]
                ? ((r = null != n ? n : U), (h = -1))
                : void 0 === a[1]
                ? (h = -2)
                : ((h = r.lastIndex - a[2].length), (l = a[1]), (r = void 0 === a[3] ? H : '"' === a[3] ? N : O))
              : r === N || r === O
              ? (r = H)
              : r === P || r === R
              ? (r = U)
              : ((r = H), (n = void 0));
        const p = r === H && t[e + 1].startsWith('/>') ? ' ' : '';
        o +=
          r === U
            ? i + A
            : h >= 0
            ? (s.push(l), i.slice(0, h) + '$lit$' + i.slice(h) + S + p)
            : i + S + (-2 === h ? (s.push(void 0), e) : p);
      }
      const l = o + (t[i] || '<?>') + (2 === e ? '</svg>' : '');
      if (!Array.isArray(t) || !t.hasOwnProperty('raw')) throw Error('invalid template strings array');
      return [void 0 !== _ ? _.createHTML(l) : l, s];
    };
  class I {
    constructor({ strings: t, _$litType$: e }, i) {
      let s;
      this.parts = [];
      let n = 0,
        o = 0;
      const r = t.length - 1,
        l = this.parts,
        [a, h] = D(t, e);
      if (((this.el = I.createElement(a, i)), (B.currentNode = this.el.content), 2 === e)) {
        const t = this.el.content,
          e = t.firstChild;
        e.remove(), t.append(...e.childNodes);
      }
      for (; null !== (s = B.nextNode()) && l.length < r; ) {
        if (1 === s.nodeType) {
          if (s.hasAttributes()) {
            const t = [];
            for (const e of s.getAttributeNames())
              if (e.endsWith('$lit$') || e.startsWith(S)) {
                const i = h[o++];
                if ((t.push(e), void 0 !== i)) {
                  const t = s.getAttribute(i.toLowerCase() + '$lit$').split(S),
                    e = /([.?@])?(.*)/.exec(i);
                  l.push({
                    type: 1,
                    index: n,
                    name: e[2],
                    strings: t,
                    ctor: '.' === e[1] ? J : '?' === e[1] ? F : '@' === e[1] ? G : W
                  });
                } else l.push({ type: 6, index: n });
              }
            for (const e of t) s.removeAttribute(e);
          }
          if (T.test(s.tagName)) {
            const t = s.textContent.split(S),
              e = t.length - 1;
            if (e > 0) {
              s.textContent = m ? m.emptyScript : '';
              for (let i = 0; i < e; i++) s.append(t[i], w()), B.nextNode(), l.push({ type: 2, index: ++n });
              s.append(t[e], w());
            }
          }
        } else if (8 === s.nodeType)
          if (s.data === b) l.push({ type: 2, index: n });
          else {
            let t = -1;
            for (; -1 !== (t = s.data.indexOf(S, t + 1)); ) l.push({ type: 7, index: n }), (t += S.length - 1);
          }
        n++;
      }
    }
    static createElement(t, e) {
      const i = E.createElement('template');
      return (i.innerHTML = t), i;
    }
  }
  function q(t, e, i = t, s) {
    var n, o, r, l;
    if (e === M) return e;
    let a = void 0 !== s ? (null === (n = i._$Co) || void 0 === n ? void 0 : n[s]) : i._$Cl;
    const h = C(e) ? void 0 : e._$litDirective$;
    return (
      (null == a ? void 0 : a.constructor) !== h &&
        (null === (o = null == a ? void 0 : a._$AO) || void 0 === o || o.call(a, !1),
        void 0 === h ? (a = void 0) : ((a = new h(t)), a._$AT(t, i, s)),
        void 0 !== s ? ((null !== (r = (l = i)._$Co) && void 0 !== r ? r : (l._$Co = []))[s] = a) : (i._$Cl = a)),
      void 0 !== a && (e = q(t, a._$AS(t, e.values), a, s)),
      e
    );
  }
  class V {
    constructor(t, e) {
      (this._$AV = []), (this._$AN = void 0), (this._$AD = t), (this._$AM = e);
    }
    get parentNode() {
      return this._$AM.parentNode;
    }
    get _$AU() {
      return this._$AM._$AU;
    }
    u(t) {
      var e;
      const {
          el: { content: i },
          parts: s
        } = this._$AD,
        n = (null !== (e = null == t ? void 0 : t.creationScope) && void 0 !== e ? e : E).importNode(i, !0);
      B.currentNode = n;
      let o = B.nextNode(),
        r = 0,
        l = 0,
        a = s[0];
      for (; void 0 !== a; ) {
        if (r === a.index) {
          let e;
          2 === a.type
            ? (e = new K(o, o.nextSibling, this, t))
            : 1 === a.type
            ? (e = new a.ctor(o, a.name, a.strings, this, t))
            : 6 === a.type && (e = new Q(o, this, t)),
            this._$AV.push(e),
            (a = s[++l]);
        }
        r !== (null == a ? void 0 : a.index) && ((o = B.nextNode()), r++);
      }
      return (B.currentNode = E), n;
    }
    v(t) {
      let e = 0;
      for (const i of this._$AV)
        void 0 !== i && (void 0 !== i.strings ? (i._$AI(t, i, e), (e += i.strings.length - 2)) : i._$AI(t[e])), e++;
    }
  }
  class K {
    constructor(t, e, i, s) {
      var n;
      (this.type = 2),
        (this._$AH = j),
        (this._$AN = void 0),
        (this._$AA = t),
        (this._$AB = e),
        (this._$AM = i),
        (this.options = s),
        (this._$Cp = null === (n = null == s ? void 0 : s.isConnected) || void 0 === n || n);
    }
    get _$AU() {
      var t, e;
      return null !== (e = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== e ? e : this._$Cp;
    }
    get parentNode() {
      let t = this._$AA.parentNode;
      const e = this._$AM;
      return void 0 !== e && 11 === (null == t ? void 0 : t.nodeType) && (t = e.parentNode), t;
    }
    get startNode() {
      return this._$AA;
    }
    get endNode() {
      return this._$AB;
    }
    _$AI(t, e = this) {
      (t = q(this, t, e)),
        C(t)
          ? t === j || null == t || '' === t
            ? (this._$AH !== j && this._$AR(), (this._$AH = j))
            : t !== this._$AH && t !== M && this._(t)
          : void 0 !== t._$litType$
          ? this.g(t)
          : void 0 !== t.nodeType
          ? this.$(t)
          : ((t) => x(t) || 'function' == typeof (null == t ? void 0 : t[Symbol.iterator]))(t)
          ? this.T(t)
          : this._(t);
    }
    k(t) {
      return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
      this._$AH !== t && (this._$AR(), (this._$AH = this.k(t)));
    }
    _(t) {
      this._$AH !== j && C(this._$AH) ? (this._$AA.nextSibling.data = t) : this.$(E.createTextNode(t)), (this._$AH = t);
    }
    g(t) {
      var e;
      const { values: i, _$litType$: s } = t,
        n = 'number' == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = I.createElement(s.h, this.options)), s);
      if ((null === (e = this._$AH) || void 0 === e ? void 0 : e._$AD) === n) this._$AH.v(i);
      else {
        const t = new V(n, this),
          e = t.u(this.options);
        t.v(i), this.$(e), (this._$AH = t);
      }
    }
    _$AC(t) {
      let e = L.get(t.strings);
      return void 0 === e && L.set(t.strings, (e = new I(t))), e;
    }
    T(t) {
      x(this._$AH) || ((this._$AH = []), this._$AR());
      const e = this._$AH;
      let i,
        s = 0;
      for (const n of t)
        s === e.length ? e.push((i = new K(this.k(w()), this.k(w()), this, this.options))) : (i = e[s]), i._$AI(n), s++;
      s < e.length && (this._$AR(i && i._$AB.nextSibling, s), (e.length = s));
    }
    _$AR(t = this._$AA.nextSibling, e) {
      var i;
      for (null === (i = this._$AP) || void 0 === i || i.call(this, !1, !0, e); t && t !== this._$AB; ) {
        const e = t.nextSibling;
        t.remove(), (t = e);
      }
    }
    setConnected(t) {
      var e;
      void 0 === this._$AM && ((this._$Cp = t), null === (e = this._$AP) || void 0 === e || e.call(this, t));
    }
  }
  class W {
    constructor(t, e, i, s, n) {
      (this.type = 1),
        (this._$AH = j),
        (this._$AN = void 0),
        (this.element = t),
        (this.name = e),
        (this._$AM = s),
        (this.options = n),
        i.length > 2 || '' !== i[0] || '' !== i[1]
          ? ((this._$AH = Array(i.length - 1).fill(new String())), (this.strings = i))
          : (this._$AH = j);
    }
    get tagName() {
      return this.element.tagName;
    }
    get _$AU() {
      return this._$AM._$AU;
    }
    _$AI(t, e = this, i, s) {
      const n = this.strings;
      let o = !1;
      if (void 0 === n) (t = q(this, t, e, 0)), (o = !C(t) || (t !== this._$AH && t !== M)), o && (this._$AH = t);
      else {
        const s = t;
        let r, l;
        for (t = n[0], r = 0; r < n.length - 1; r++)
          (l = q(this, s[i + r], e, r)),
            l === M && (l = this._$AH[r]),
            o || (o = !C(l) || l !== this._$AH[r]),
            l === j ? (t = j) : t !== j && (t += (null != l ? l : '') + n[r + 1]),
            (this._$AH[r] = l);
      }
      o && !s && this.j(t);
    }
    j(t) {
      t === j ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : '');
    }
  }
  class J extends W {
    constructor() {
      super(...arguments), (this.type = 3);
    }
    j(t) {
      this.element[this.name] = t === j ? void 0 : t;
    }
  }
  const Z = m ? m.emptyScript : '';
  class F extends W {
    constructor() {
      super(...arguments), (this.type = 4);
    }
    j(t) {
      t && t !== j ? this.element.setAttribute(this.name, Z) : this.element.removeAttribute(this.name);
    }
  }
  class G extends W {
    constructor(t, e, i, s, n) {
      super(t, e, i, s, n), (this.type = 5);
    }
    _$AI(t, e = this) {
      var i;
      if ((t = null !== (i = q(this, t, e, 0)) && void 0 !== i ? i : j) === M) return;
      const s = this._$AH,
        n = (t === j && s !== j) || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive,
        o = t !== j && (s === j || n);
      n && this.element.removeEventListener(this.name, this, s),
        o && this.element.addEventListener(this.name, this, t),
        (this._$AH = t);
    }
    handleEvent(t) {
      var e, i;
      'function' == typeof this._$AH
        ? this._$AH.call(
            null !== (i = null === (e = this.options) || void 0 === e ? void 0 : e.host) && void 0 !== i
              ? i
              : this.element,
            t
          )
        : this._$AH.handleEvent(t);
    }
  }
  class Q {
    constructor(t, e, i) {
      (this.element = t), (this.type = 6), (this._$AN = void 0), (this._$AM = e), (this.options = i);
    }
    get _$AU() {
      return this._$AM._$AU;
    }
    _$AI(t) {
      q(this, t);
    }
  }
  const X = f.litHtmlPolyfillSupport;
  null == X || X(I, K), (null !== (g = f.litHtmlVersions) && void 0 !== g ? g : (f.litHtmlVersions = [])).push('2.7.4');
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */
  var Y, tt;
  class et extends y {
    constructor() {
      super(...arguments), (this.renderOptions = { host: this }), (this._$Do = void 0);
    }
    createRenderRoot() {
      var t, e;
      const i = super.createRenderRoot();
      return (
        (null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t) || (e.renderBefore = i.firstChild), i
      );
    }
    update(t) {
      const e = this.render();
      this.hasUpdated || (this.renderOptions.isConnected = this.isConnected),
        super.update(t),
        (this._$Do = ((t, e, i) => {
          var s, n;
          const o = null !== (s = null == i ? void 0 : i.renderBefore) && void 0 !== s ? s : e;
          let r = o._$litPart$;
          if (void 0 === r) {
            const t = null !== (n = null == i ? void 0 : i.renderBefore) && void 0 !== n ? n : null;
            o._$litPart$ = r = new K(e.insertBefore(w(), t), t, void 0, null != i ? i : {});
          }
          return r._$AI(t), r;
        })(e, this.renderRoot, this.renderOptions));
    }
    connectedCallback() {
      var t;
      super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
      var t;
      super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
      return M;
    }
  }
  (et.finalized = !0),
    (et._$litElement$ = !0),
    null === (Y = globalThis.litElementHydrateSupport) || void 0 === Y || Y.call(globalThis, { LitElement: et });
  const it = globalThis.litElementPolyfillSupport;
  null == it || it({ LitElement: et }),
    (null !== (tt = globalThis.litElementVersions) && void 0 !== tt ? tt : (globalThis.litElementVersions = [])).push(
      '3.3.2'
    );
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */
  const st = (t, e) =>
    'method' === e.kind && e.descriptor && !('value' in e.descriptor)
      ? {
          ...e,
          finisher(i) {
            i.createProperty(e.key, t);
          }
        }
      : {
          kind: 'field',
          key: Symbol(),
          placement: 'own',
          descriptor: {},
          originalKey: e.key,
          initializer() {
            'function' == typeof e.initializer && (this[e.key] = e.initializer.call(this));
          },
          finisher(i) {
            i.createProperty(e.key, t);
          }
        };
  function nt(t) {
    return (e, i) =>
      void 0 !== i
        ? ((t, e, i) => {
            e.constructor.createProperty(i, t);
          })(t, e, i)
        : st(t, e);
    /**
     * @license
     * Copyright 2017 Google LLC
     * SPDX-License-Identifier: BSD-3-Clause
     */
  }
  function ot(t) {
    return nt({ ...t, state: !0 });
  }
  /**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ var rt;
  null === (rt = window.HTMLSlotElement) || void 0 === rt || rt.prototype.assignedElements;
  class lt extends et {
    constructor() {
      super(...arguments), (this.datalistState = []);
    }
    set value(t) {
      var e;
      if ('string' == typeof t) {
        this.valueState = t;
        const i = null === (e = this.shadowRoot) || void 0 === e ? void 0 : e.querySelector('input');
        i && (i.value = t), this.requestUpdate();
      }
    }
    set datalist(t) {
      t && ((this.datalistState = JSON.parse(t)), this.requestUpdate());
    }
    set error(t) {
      var e;
      if ('string' == typeof t && t.length > 0) {
        this.errorState = t;
        const i = null === (e = this.shadowRoot) || void 0 === e ? void 0 : e.querySelector('input');
        i && i.setCustomValidity(this.errorState);
      } else this.errorState = void 0;
      this.requestUpdate();
    }
    set size(t) {
      const e = ['sm', 'lg'].includes(t) ? t : '';
      (this.sizeState = e.length > 0 ? 'input-group-' + e : ''), this.requestUpdate();
    }
    firstUpdated() {
      var t;
      const e = null === (t = this.shadowRoot) || void 0 === t ? void 0 : t.querySelector('input');
      e && this.errorState && e.setCustomValidity(this.errorState);
    }
    handleEvent(t, e) {
      var i, s;
      const n =
        null === (s = null === (i = this.shadowRoot) || void 0 === i ? void 0 : i.querySelector('input')) ||
        void 0 === s
          ? void 0
          : s.value;
      let o;
      switch (e) {
        case 'change':
          o = new CustomEvent(e, { bubbles: !0, composed: !0, detail: { value: n } });
          break;
        case 'keyup':
          const i = t;
          o = new CustomEvent(e, {
            bubbles: !0,
            composed: !0,
            detail: {
              key: i.key,
              keyCode: i.keyCode,
              code: i.code,
              ctrlKey: i.ctrlKey,
              altKey: i.altKey,
              isComposing: i.isComposing,
              charCode: i.charCode,
              shiftKey: i.shiftKey,
              repeat: i.repeat,
              location: i.location,
              composed: i.composed,
              value: n
            }
          });
          break;
        default:
          o = new Event(e, { bubbles: !0, composed: !0 });
      }
      (this.value = String(n)), this.dispatchEvent(o);
    }
    render() {
      return z`
      ${z`
  <link
    rel="stylesheet"
    href="https://storybook.talentech.io/css/${
      (null === (t = document.querySelector('body')) || void 0 === t
      ? void 0
      : t.classList.contains('visma'))
        ? 'themes/visma/bundle.css'
        : '0.4.97/bundle.min.css'
    }"
  />
  <!-- <link rel="stylesheet" href="https://storybook.talentech.io/css/themes/visma/bundle.css" /> -->
  <link
    rel="stylesheet"
    href="https://static.talentech.io/fonts/Telegraf/talentech-telegraf.css"
  />
  <link
    rel="stylesheet"
    href="https://static.talentech.io/googlefonts/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap"
  />
  <link rel="stylesheet" href="https://static.talentech.io/iconfont/TIconography/style.css" />
`}
      ${
        this.icon
          ? z`
            ${
              this.label
                ? z`
                  <label for="${this.id}" class="form-label">${this.label}</label>
                `
                : ''
            }
            <div class="input-group ${this.sizeState}">
              <span class="input-group-text"><i class="t-icon ${this.icon}"></i></span>
              <input
                ?disabled=${'true' === this.disabled}
                min=${this.min || j}
                max=${this.max || j}
                step=${this.step || j}
                type="${this.type}"
                class="${'range' === this.type ? 'form-range' : 'form-control'} ${this.class} ${
              this.errorState ? 'is-invalid' : ''
            }
                "
                style=${this.styles || j}
                aria-label="${this.label ? this.label : 'input element'}"
                id=${this.id || j}
                list=${'list-' + this.id || j}
                placeholder=${this.placeholder || j}
                value="${((t) => (null != t ? t : j))(this.valueState)}"
                @click="${(t) => {
                  this.handleEvent(t, 'click');
                }}"
                @change="${(t) => {
                  this.handleEvent(t, 'change');
                }}"
                @keyup="${(t) => {
                  this.handleEvent(t, 'keyup');
                }}"
                @mouseover="${(t) => {
                  this.handleEvent(t, 'mouseover');
                }}"
                @submit="${(t) => {
                  this.handleEvent(t, 'submit');
                }}"
              />
              ${
                this.datalistState.length > 0
                  ? z`
                    <datalist id="${'list-' + this.id}">
                      ${this.datalistState.map(
                        (t) => z`
                          <option label="${t.label}" value="${t.value}"></option>
                        `
                      )}
                    </datalist>
                  `
                  : j
              }
              ${
                this.errorState
                  ? z`
                    <div class="invalid-feedback">
                      ${this.errorState}
                    </div>
                  `
                  : ''
              }
            </div>
          `
          : this.label
          ? z`
            <label for="${this.id}" class="form-label">${this.label}</label>
            <div class="input-group ${this.sizeState}">
              <input
                ?disabled=${'true' === this.disabled}
                min=${this.min || j}
                max=${this.max || j}
                step=${this.step || j}
                style=${this.styles || j}
                id=${this.id || j}
                list=${'list-' + this.id || j}
                type="${this.type}"
                class="${'range' === this.type ? 'form-range' : 'form-control'} ${this.class} ${
              this.errorState ? 'is-invalid' : ''
            }"
                placeholder=${this.placeholder || j}
                aria-label="${this.label ? this.label : 'input element'}"
                value="${this.valueState}"
                @click="${(t) => {
                  this.handleEvent(t, 'click');
                }}"
                @change="${(t) => {
                  this.handleEvent(t, 'change');
                }}"
                @keyup="${(t) => {
                  this.handleEvent(t, 'keyup');
                }}"
                @mouseover="${(t) => {
                  this.handleEvent(t, 'mouseover');
                }}"
                @submit="${(t) => {
                  this.handleEvent(t, 'submit');
                }}"
              />
              ${
                this.datalistState.length > 0
                  ? z`
                    <datalist id="${'list-' + this.id}">
                      ${this.datalistState.map(
                        (t) => z`
                          <option label="${t.label}" value="${t.value}"></option>
                        `
                      )}
                    </datalist>
                  `
                  : j
              }
            </div>
            ${
              this.errorState
                ? z`
                  <div class="invalid-feedback">
                    ${this.errorState}
                  </div>
                `
                : ''
            }
          `
          : z`
            <div class="input-group ${this.sizeState}">
              <input
                ?disabled=${'true' === this.disabled}
                min=${this.min || j}
                max=${this.max || j}
                step=${this.step || j}
                type="${this.type}"
                style=${this.styles || j}
                class="${'range' === this.type ? 'form-range' : 'form-control'} ${this.class} ${
              this.errorState ? 'is-invalid' : ''
            }"
                aria-label="${this.label ? this.label : 'input element'}"
                id=${this.id || j}
                list=${'list-' + this.id || j}
                placeholder=${this.placeholder || j}
                value="${this.valueState}"
                @click="${(t) => {
                  this.handleEvent(t, 'click');
                }}"
                @change="${(t) => {
                  this.handleEvent(t, 'change');
                }}"
                @keyup="${(t) => {
                  this.handleEvent(t, 'keyup');
                }}"
                @mouseover="${(t) => {
                  this.handleEvent(t, 'mouseover');
                }}"
                @submit="${(t) => {
                  this.handleEvent(t, 'submit');
                }}"
              />
              ${
                this.datalistState.length > 0
                  ? z`
                    <datalist id="${'list-' + this.id}">
                      ${this.datalistState.map(
                        (t) => z`
                          <option label="${t.label}" value="${t.value}"></option>
                        `
                      )}
                    </datalist>
                  `
                  : j
              }
              ${
                this.errorState
                  ? z`
                    <div class="invalid-feedback">
                      ${this.errorState}
                    </div>
                  `
                  : ''
              }
            </div>
          `
      }
    `;
      var t;
    }
  }
  (lt.styles = [
    ((t, ...e) => {
      const i =
        1 === t.length
          ? t[0]
          : e.reduce(
              (e, i, s) =>
                e +
                ((t) => {
                  if (!0 === t._$cssResult$) return t.cssText;
                  if ('number' == typeof t) return t;
                  throw Error(
                    "Value passed to 'css' function must be a 'css' function result: " +
                      t +
                      ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security."
                  );
                })(i) +
                t[s + 1],
              t[0]
            );
      return new r(i, t, n);
    })`
      :host {
        display: block;
      }
      .invalid-feedback {
        display: block;
      }
      .input-group-text {
        display: flex;
        align-items: center;
        padding: 0.625rem 0.625rem;
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.125rem;
        color: var(--bs-dark);
        text-align: center;
        white-space: nowrap;
        background-color: #ffffff;
        border: 1px solid var(--bs-gray-600);
        border-radius: 0.25rem;
      }
      input.form-control {
        height: 42px;
      }
      .input-group-sm input,
      .input-group-sm span.input-group-text {
        height: 32px;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
      }
      .input-group-sm i.t-icon {
        font-size: 0.9rem !important;
      }
      .input-group-lg input,
      .input-group-lg span.input-group-text {
        height: 48px;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
      }
      .input-group-lg i.t-icon {
        font-size: 1.5rem !important;
      }
      .form-control:focus {
        background-color: white;
      }
      i[class^='icon-'],
      i.t-icon {
        font-size: 1.25rem;
      }
      datalist {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        font-family: Open Sans;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        text-align: left;
      }
    `
  ]),
    t([nt({ type: String }), e('design:type', String)], lt.prototype, 'id', void 0),
    t([nt({ type: String }), e('design:type', String)], lt.prototype, 'class', void 0),
    t([nt({ type: String }), e('design:type', String)], lt.prototype, 'placeholder', void 0),
    t([nt({ type: String }), e('design:type', String)], lt.prototype, 'type', void 0),
    t([nt({ type: String }), e('design:type', String)], lt.prototype, 'label', void 0),
    t([nt({ type: String }), e('design:type', String)], lt.prototype, 'icon', void 0),
    t([nt({ type: String }), e('design:type', String)], lt.prototype, 'styles', void 0),
    t([nt({ type: String }), e('design:type', String)], lt.prototype, 'min', void 0),
    t([nt({ type: String }), e('design:type', String)], lt.prototype, 'max', void 0),
    t([nt({ type: String }), e('design:type', String)], lt.prototype, 'step', void 0),
    t([nt({ type: String }), e('design:type', String), e('design:paramtypes', [String])], lt.prototype, 'value', null),
    t(
      [nt({ type: String }), e('design:type', String), e('design:paramtypes', [String])],
      lt.prototype,
      'datalist',
      null
    ),
    t([nt({ type: String }), e('design:type', String), e('design:paramtypes', [String])], lt.prototype, 'error', null),
    t([nt({ type: String }), e('design:type', String), e('design:paramtypes', [String])], lt.prototype, 'size', null),
    t([ot(), e('design:type', String)], lt.prototype, 'sizeState', void 0),
    t([nt({ type: String }), e('design:type', String)], lt.prototype, 'disabled', void 0),
    t([ot(), e('design:type', String)], lt.prototype, 'valueState', void 0),
    t([ot(), e('design:type', String)], lt.prototype, 'errorState', void 0),
    t([ot(), e('design:type', Array)], lt.prototype, 'datalistState', void 0),
    window.customElements.define('input-talentech', lt);
})();
